import { connect } from 'react-redux';
import { identificationType } from '../../../shared/constants';
import Toolbar from './toolbar';
import { createArticleLink } from '../../utils/linkCreator';
import { BREAKPOINT_MOBILE_IN_PX } from '../../constants';

const createAccessibleFormatUrl = ({
  idType, pdfContent: { identification = {} },
}) => (idType === identificationType.pii ? createArticleLink(identification) : null);

const mapStateToProps = state => ({
  accessibleFormatUrl: createAccessibleFormatUrl(state),
  downloadUrl: state.pdfContent.pdfDownloadEndpoint,
  isSearching: state.find.isSearching,
  isLoadingDocumentForPrint: state.isLoadingDocumentForPrint,
  sidePanelOpen: state.sidebar.isOpen,
  viewerFeature: state.viewConfig.viewerFeature,
  isSmallestBreakpoint: BREAKPOINT_MOBILE_IN_PX < state.clientSize.width,
});

export default connect(mapStateToProps)(Toolbar);
